<template>
    <div>
        <div class="profileContainer">
            <HeadCard />
            <div style="margin-top: 10px;">
                <VipCard />
            </div>
            <MenuCard />
        </div>
        <div style="padding-top: 70px;">
        <MainFooter :itemData="userStore.footerComponent" :active-footer="4" />
        </div>

    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import HeadCard from './components/headCard.vue'
import VipCard from './components/vipCard.vue'
import MenuCard from './components/menuCard.vue'
import MainFooter from '../components/common/mainFooter.vue'
import { ProfilePoupData } from '@/view/profile/supportScript'
import { useUserStore } from '@/stores/user';
const userStore = useUserStore()

const props = defineProps<{
    dataSet: ProfilePoupData
}>()

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const emits = defineEmits(['close', 'clickBanner', 'update:show'])


const close = () => {
    emits('close')
}
const clickBanner = () => {
    emits('clickBanner')
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};
defineExpose({
    open,
    close
})

</script>
<style scoped>
.profileContainer {
    padding: 10px;
   background: #090f1f;
   min-height: 100vh;
}
</style>